module.exports = __webpack_public_path__ + "img/corel.a671f267.png";